import { Modal } from '@evaneos/b2b-ui/legacy';
import { Button } from '@evaneos/b2b-ui';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { CircularLoader } from '../../../../../design-system/Loader/CircularLoader';
import { GlobalLoader } from '../../../../../shared/components/layout/GlobalLoader';
import { SidePanelViewMode } from '../../../SidePanel/types';
import { goToPreviousStep } from '../../../../../resources/contract/actions';
import { shouldRecreatePaymentSchedule as shouldRecreatePaymentScheduleSelector } from '../../../../../resources/contract/selectors';
import { useAppDispatch, useAppSelector } from '../../../../../shared/redux';

import s from './StepButtons.module.css';

type Props = {
    isNextStepDisabled: boolean;
    isLoading: boolean;
    dataTestId: string;
    onClickBack?: () => void;
    isPaymentScheduleCreated?: boolean;
    viewMode?: SidePanelViewMode;
};

export const StepButtons = ({
    isLoading,
    isNextStepDisabled,
    onClickBack,
    dataTestId,
    isPaymentScheduleCreated,
    viewMode,
}: Props): JSX.Element => {
    const intl = useIntl();

    const dispatch = useAppDispatch();

    const shouldRecreatePaymentSchedule = useAppSelector(shouldRecreatePaymentScheduleSelector);

    const [isBackModalOpened, setIsBackModalOpened] = useState(false);
    const buttonMessageId =
        isPaymentScheduleCreated || shouldRecreatePaymentSchedule
            ? 'contract.payment_schedule.validate'
            : 'contract.next_step';
    return (
        <div className={s.buttonContainer} {...(viewMode && { 'data-contract-view': viewMode })}>
            <Button
                variant="outlined"
                onClick={() => (onClickBack ? onClickBack() : setIsBackModalOpened(true))}
                type="button"
                className={s.backButton}
                data-testid="button-back"
            >
                <FormattedMessage id="global.back" />
            </Button>
            <Button
                type="submit"
                color="primary"
                disabled={isNextStepDisabled || isLoading}
                className={s.buttonValidate}
                data-testid={dataTestId}
            >
                {isLoading ? (
                    <div className={s.loadingButton}>
                        <CircularLoader data-testid="sending-message-loader" />
                        <GlobalLoader />
                    </div>
                ) : (
                    <FormattedMessage id={buttonMessageId} />
                )}
            </Button>

            <Modal
                isOpen={isBackModalOpened}
                title={intl.formatMessage({
                    id: 'contract.confirm_go_back.title',
                })}
                onRequestClose={() => setIsBackModalOpened(false)}
                mainButton={
                    <Button
                        color="primary"
                        onClick={() => {
                            dispatch(goToPreviousStep());
                            setIsBackModalOpened(false);
                        }}
                        data-testid="button-confirm-go-back"
                    >
                        <FormattedMessage id="form.submit" />
                    </Button>
                }
                secondaryButton={
                    <Button
                        variant="outlined"
                        onClick={() => setIsBackModalOpened(false)}
                        data-testid="button-cancel-go-back"
                    >
                        <FormattedMessage id="form.cancel" />
                    </Button>
                }
            >
                <p>
                    <FormattedMessage id="contract.confirm_go_back.description" />
                </p>
            </Modal>
        </div>
    );
};
